import * as React                  from 'react';
import { useTranslation }          from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { Navigation, Pagination }  from 'swiper/modules';
import { Swiper, SwiperSlide }     from 'swiper/react';

import InternalVideo from '../../../../components/internal-video';
import { useModal }  from '../../../../providers/modal';

import { upper } from '../../utils';

import CompletedProjectArrowLeft  from '../arrow-left';
import CompletedProjectArrowRight from '../arrow-right';
import CompletedProjectButton     from '../button';
import CompletedProjectModal      from '../modal';
import CompletedProjectPicture    from '../picture';

import { CompletedProjectItemProps, GalleryItem } from './completed-project.item.props';
import './completed-project.item.style.scss';

const CompletedProjectItem: React.FC<CompletedProjectItemProps> = function(props) {
  const history  = useHistory();
  const location = useLocation();
  const { t }    = useTranslation();

  const {
          doorHandle,
          gallery,
          id,
          inside,
          label,
          outside,
          series,
        } = props;

  const modal: any = useModal();

  const arrowLeftRef  = React.useRef<HTMLDivElement | null>(null);
  const arrowRightRef = React.useRef<HTMLDivElement | null>(null);
  const paginationRef = React.useRef<HTMLDivElement | null>(null);

  const parameters = React.useMemo(() => {
    const items: Record<string, string> = {};

    if (typeof outside === 'string' && outside.trim().length > 0) {
      items.outside_title = outside;
    }

    if (typeof inside === 'string' && inside.trim().length > 0) {
      items.inside_title = inside;
    }

    if (typeof doorHandle === 'string' && doorHandle.trim().length > 0) {
      items.door_handle_title = doorHandle;
    }

    return items;
  }, [doorHandle, inside, outside]);
  const slides     = React.useMemo(() => {
    return gallery
      .sort((a, b) => {
        return a.priority < b.priority ? -1 : 1;
      })
      .map((item) => {
        return {
          priority: item.priority,
          src:      item.src,
          type:     item.type,
        } as GalleryItem;
      });
  }, [gallery]);

  const handleOpen = React.useCallback(() => {
    const pathname = location.pathname;

    history.replace(`${pathname}?id=${id}`);
    modal.showModal(
      '',
      {
        component: CompletedProjectModal,
        props:     {
          ...props,
          onClose() {
            history.replace(pathname);
          },
        },
      },
      true,
    );
  }, [location.pathname, props]);

  return (
    <div
      className={'completed-project-item'}
      onClick={handleOpen}
    >
      <div className={'gallery'}>
        <Swiper
          loop
          modules={[Navigation, Pagination]}
          navigation={{
            nextEl: arrowRightRef.current,
            prevEl: arrowLeftRef.current,
          }}
          observer
          pagination={{
            bulletActiveClass: 'swiper-pagination-bullet-active',
            bulletClass:       'swiper-pagination-bullet',
            clickable:         false,
            el:                paginationRef.current,
            type:              'bullets',
          }}
          slidesPerView={1}
        >
          {slides.map((slide) => {
            return (
              <SwiperSlide key={slide.priority}>
                {slide.type?.startsWith('image')
                  ? (
                    <CompletedProjectPicture
                      src={slide.src}
                      type={slide.type}
                    />
                  )
                  : slide.type?.startsWith('video')
                    ? <InternalVideo src={slide.src} />
                    : null
                }
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div ref={paginationRef} />
        <CompletedProjectArrowLeft ref={arrowLeftRef} />
        <CompletedProjectArrowRight ref={arrowRightRef} />
      </div>
      <div className={'label'}>{label}</div>
      {/* {Object.keys(parameters).length > 0 && ( */}
      {/*   <ul className={'parameters'}> */}
      {/*     {Object */}
      {/*       .entries(parameters) */}
      {/*       .map(([key, value]) => { */}
      {/*         return <li key={key}>{upper(t(key))}: {value}</li>; */}
      {/*       }) */}
      {/*     } */}
      {/*   </ul> */}
      {/* )} */}
      {/* <div className={'series'}>{upper(t('series_label'))} {series}</div> */}
      <CompletedProjectButton id={id} />
    </div>
  );
};

export default CompletedProjectItem;